import { StatusBadge, type StatusBadgeProps } from '@vrplatform/components';
import type { syncStatus_enum } from '@vrplatform/graphql';
import { type Maybe, toTitleCase } from '@vrplatform/utils';

const AUTOMATION_HISTORY_STATUS_BADGE_MAP = {
  canceled: 'disabled',
  completed: 'success',
  failed: 'error',
  queued: 'pending',
  started: 'pending',
} as const satisfies Record<syncStatus_enum, StatusBadgeProps['status']>;

const hasOwnKey = <T extends object>(
  object: T,
  key: PropertyKey
): key is keyof T => {
  return Object.prototype.hasOwnProperty.call(object, key);
};

export const AutomationHistoryStatusBadge = ({
  status,
}: {
  status: Maybe<string>;
}) => {
  if (!status || !hasOwnKey(AUTOMATION_HISTORY_STATUS_BADGE_MAP, status)) {
    return null;
  }

  return (
    <StatusBadge
      label={toTitleCase(status)}
      size="lg"
      status={AUTOMATION_HISTORY_STATUS_BADGE_MAP[status]}
    />
  );
};
